/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";

export class OktoberfestGameAssets {

    static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    static BITMAP_FONT_WIN_COUNT_UP = "of_countfont";
    public static BITMAP_FONT_MULTIPLIER: string = "NumbersMultiplier";
    public static MAIN_GAME_BACKGROUND: string = "background";
    public static FS_BACKGROUND: string = "freespinBackground";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset(OktoberfestGameAssets.BITMAP_FONT_WIN_COUNT_UP, "fonts/bitmapFonts/of_countfont.fnt"),
                    new BitmapFontAsset(OktoberfestGameAssets.BITMAP_FONT_MULTIPLIER, "fonts/bitmapFonts/NumbersOpenSans800.fnt")
                ]
            },
            {
                name: "main",
                autoLoad:[AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json")
                ],
                animations: {
                    "background": "background/background",
                    "foreground": "background/foreground",
                    "foreground2": "background/foreground2",
                    "foreground@0.5x": "background/foreground@0.5x",
                    "foreground_mobile_landscape_top": "background/foreground_mobile_landscape_top",
                    "foreground_portrait": "background/foreground_portrait",
                    "reel-cogs": "animationframes/reel-cogs/reel-cogs_",
                    "bw_banner": "animationframes/bw_banner/bw_banner_",
                    "bw_step1": "animationframes/bw_step1/bigwin-step1_",
                    "bw_step_outro1": "animationframes/bw_step1/bigwin-step-outro1_",
                    "bw_step2": "animationframes/bw_step2/bigwin-step2_",
                    "bw_step_outro2": "animationframes/bw_step2/bigwin-step-outro2_",
                    "bw_step3": "animationframes/bw_step3/bigwin-step3_",
                    "bw_step_outro3": "animationframes/bw_step3/bigwin-step-outro3_",
                    "flagsUp": "animationframes/flags/flagUp/flags_",
                    "fsbtn-click": "animationframes/fsbtn-click/startfsbtn-click_",
                    "fsbtn-hover": "animationframes/fsbtn-hover/startfsbtn-hover_",
                    "fsbtn-in": "animationframes/fsbtn-in/startfsbtn-in_",
                    "logo-fs": "animationframes/logo-fs/logo-fs_",
                    "meter-in": "animationframes/meter-in/meterin_",
                    "multiplier-in": "animationframes/multiplier-in/multi-in_",
                    "multiplier-up": "animationframes/multiplier-up/multiup_",
                    "multiplier-win": "animationframes/multiplier-win/multiwin_",
                    "bw1": "bigwin/bw1",
                    "bw2": "bigwin/bw2",
                    "bw3": "bigwin/bw3",
                    "add3fs": "transitions/freespinIntro/add3fs",
                    "arrow": "transitions/freespinIntro/arrow",
                    "banner": "transitions/freespinIntro/banner",
                    "beerGlass": "transitions/freespinIntro/beer-glass",
                    "beer-glass_mask": "transitions/freespinIntro/beer-glass_mask",
                    "meter-base": "transitions/freespinIntro/meter-base",
                    "meter-fill": "transitions/freespinIntro/meter-fill",
                    "meter-mask": "transitions/freespinIntro/meter-mask",
                    "meter-steps": "transitions/freespinIntro/meter-steps",
                    "fsOutroTextImage": "transitions/freespinOutro/beeindruckend",
                    "meterStartAnimation": "animationframes/meter-in/meterin_",
                    "meterBase": "transitions/freespinIntro/meter-base",
                    "meterFill": "transitions/freespinIntro/meter-fill",
                    "meterMask": "transitions/freespinIntro/meter-mask",
                    "meterSteps": "transitions/freespinIntro/meter-steps",
                    "addThreeFsIcon": "transitions/freespinIntro/add3fs",
                    "freespinContinueBtnIntroAnimationShadow": "animationframes/btn_shadow_in/btn-shadow_",
                    "freespinContinueBtnClickAnimationShadow": "animationframes/btn_shadow_out/btn-shadow-out_",
                    "freespinIntroFreespinWinNumber": "animationframes/ten-fs/10_",
                    "fsIntroArrow": "transitions/freespinIntro/arrow",
                    "beer": "transitions/freespinIntro/beer",
                    "beerGlassMask": "transitions/freespinIntro/beer-glass_mask",
                    "beerLiquid": "animationframes/beer_liquid/Beer glass_"
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json")
                ],
                animations: {
                    "mainBackgroundImage": "background/main_landscape_background",
                    "win-lightup_bg": "background/win-lightup_bg",
                    "win-lightup_fg": "background/win-lightup_fg",
                    "particle_win1": "particles/particle_win1",
                    "particle_win2": "particles/particle_win2",
                    "particle_win3": "particles/particle_win3",
                    "beer": "transitions/freespinIntro/beer",
                    "freespinOutroBackground": "transitions/freespinOutro/fs_background",
                    "partyModeGoldBorder": "transitions/partyMode/gold_border",
                    "partyIntroParticles": "transitions/partyMode/partymode-particles",
                }
            },
            {
                name: "highResPng",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("highResPng0", "sheets/highResPng/highResPng0.json")
                ],
                animations: {
                    "logo": "ui/logo",
                    "topOverlay": "ui/thin_topgradient",
                    "reelDivider": "ui/reelDividers/div",
                    "chainPart": "ui/reelDividers/chain",
                    "chainGlowPart": "ui/reelDividers/chain_glow",
                    "nearWinReelDivider": "ui/reelDividers/div-attention",
                }
            },
            {
                name: "symbolsHigh",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbolsHigh0", "sheets/symbolsHigh/symbolsHigh0.json"),
                    ],
                animations: {}
                },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json"),
                    new TextureAsset("symbols2", "sheets/symbols/symbols2.json"),
                    new TextureAsset("symbols3", "sheets/symbols/symbols3.json"),
                    new TextureAsset("symbols4", "sheets/symbols/symbols4.json"),
                    new TextureAsset("symbols5", "sheets/symbols/symbols5.json"),
                    new TextureAsset("symbols6", "sheets/symbols/symbols6.json"),
                    new TextureAsset("symbols7", "sheets/symbols/symbols7.json"),
                    new TextureAsset("symbols8", "sheets/symbols/symbols8.json"),
                    new TextureAsset("symbols9", "sheets/symbols/symbols9.json"),
                    new TextureAsset("symbols10", "sheets/symbols/symbols10.json"),
                    new TextureAsset("symbols11", "sheets/symbols/symbols11.json"),
                    new TextureAsset("symbols12", "sheets/symbols/symbols12.json"),
                    new TextureAsset("symbols13", "sheets/symbols/symbols13.json")
                ],
                animations: {
                    "L1_win": "L1/L1_win/L1_win_",
                    "L2_win": "L2/L2_win/L2_win_",
                    "L3_win": "L3/L3_win/L3_win_",
                    "L4_win": "L4/L4_win/L4_win_",
                    "L5_win": "L5/L5_win/L5_win_",
                    "M1_win": "M1/M1_win/M1_win_",
                    "M2_win": "M2/M2_win/M2_win_",
                    "M3_win": "M3/M3_win/M3_win_",
                    "M4_win": "M4/M4_win/M4_win_",
                    "M5_win": "M5/M5_win/M5_win_",
                    "S": "S/S",
                    "S_att": "S/S_att/S_att_",
                    "W_rotation": "W/W_rotation/wild-rotation_",
                    "W_win": "W/W_win/W_win_",
                    "W1_1": "W1/W1_1/W1_1_",
                    "W1_2": "W1/W1_2/W1_2_",
                    "W1_3": "W1/W1_3/W1_3_",
                    "W1_att": "W1/W1_att/W1_att_",
                    "W1_win": "W1/W1_win/W1_win__",
                    "W2_1": "W2/W2_1/W2_1_",
                    "W2_2": "W2/W2_2/W2_2_",
                    "W2_3": "W2/W2_3/W2_3_",
                    "W2_att": "W2/W2_att/w2_att_",
                    "W2_win": "W2/W2_win/W2_win__",
                    "W3_att": "W3/W3_att/W3-attention_",
                    "W3_land": "W3/W3_att2/W3-attention2_",
                    "W3_drop": "W3/W3_drop/w3-drop_",
                    "W3_win": "W3/W3_win/W3_win_",
                }
            },
            {
                name: "spine",
                assets: [
                    //new SpineAsset(OktoberfestGameAssets.M1_SPINE, "spine/M1.json"),
                ]
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, state?: string): string {
        let texturePath: string = symbolName;
        if (symbolName.indexOf("_") > -1) {
            texturePath = `${symbolName.split("_")[0]}/${symbolName}`;
        } else if (symbolName.indexOf("-") > -1) {
            texturePath = `${symbolName.split("-")[0]}/${symbolName}`;
        } else {
            if (symbolName.indexOf("W") > -1 && symbolName.indexOf("g") > -1) {
                texturePath = (symbolName.length === 2) ? `${symbolName[0]}/${symbolName}` : `${symbolName}/${symbolName}`;
            } else {
                texturePath = (symbolName.length > 2) ? `${symbolName[0]}${symbolName[1]}/${symbolName}` : `${symbolName}/${symbolName}`;
            }
        }
        return texturePath;
    }
}